/** Linked messaging channels (block 24). */
import { linkCodeResponseSchema, linkedChannelListSchema, } from "@nook/schema";
export function listLinkedChannels(http) {
    return http.request({ path: "/v1/channels", schema: linkedChannelListSchema });
}
/** `503 whatsapp_unconfigured` when the backend has no WhatsApp env (A5 C15). */
export function createLinkCode(http) {
    return http.request({
        path: "/v1/channels/link-code",
        method: "POST",
        body: { channelType: "whatsapp" },
        schema: linkCodeResponseSchema,
    });
}
/** `204` whether or not the channel was still there. */
export function unlinkChannel(http, id) {
    return http.request({ path: `/v1/channels/${id}`, method: "DELETE", schema: { parse: () => undefined } });
}
//# sourceMappingURL=channels.js.map